export class GetCwsPlanGoodsCategoryListModel {
  // 受注コード
  public orderCode: string = <string>'';
  // 部門コード
  public classCode: string = <string>'';
  // カテゴリコード
  public categoryCode: string = <string>'';
  // 生協コード
  public coopCodeList: Array<any> = null;
  // サイト区分
  public siteDiv: string = <string>'';
  // 媒体
  public mediumType: string = <string>'';
}
